export default class FloatingLabels {
	element: any;
	active: Boolean;

	constructor(el: any) {
		this.element = el;

		this.init();
	}

	init() {
		this.checkElement();
		this.listen();
	}

	checkElement() {
		const { element: el } = this;
		const input = el.querySelector('input');

		if (input.value.length > 0) {
			el.setAttribute('data-floated', "true");
		}
	}

	listen() {
		this.element.addEventListener("click", e => {
			e.stopPropagation();
			e.target.parentNode.setAttribute("data-floated", "true");
		});

		const input = this.element.querySelector("input");
		if (input) {
			input.addEventListener("focus", e => {
				e.stopPropagation();
				e.target.parentNode.setAttribute("data-floated", "true");
			});

			input.addEventListener("blur", e => {
				e.stopPropagation();

				if (input.value == '') {
					e.target.parentNode.setAttribute("data-floated", "false");
				}
			});
		}
	}

	setActive() {
		this.active = true;
	}
}